import React from "react";
import { VideosCard } from "./VideosCard";
import style from "./Videos.module.css";

import vid1 from "../../../assets/contenido/vid1.png";
import vid2 from "../../../assets/contenido/vid2.png";

export const Videos = () => {
  return (
    <div className={style.container}>
      <VideosCard vid={vid1} title={"Proceso Velas"}></VideosCard>
      <VideosCard vid={vid2} title={"Rellenado de Velas"}></VideosCard>
    </div>
  );
};
